"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RegistrationPageState;
(function (RegistrationPageState) {
    RegistrationPageState[RegistrationPageState["GettingStarted"] = 0] = "GettingStarted";
    RegistrationPageState[RegistrationPageState["RegistrationForm"] = 1] = "RegistrationForm";
    RegistrationPageState[RegistrationPageState["Review"] = 2] = "Review";
})(RegistrationPageState || (RegistrationPageState = {}));
exports.default = RegistrationPageState;
